import noticeError from "src/app/utilities/noticeError";
import { addPageAction } from "./newrelic";

let uninstallWatchdog;

// Heartbeat used by New Relic alerting to detect pages that never hydrate
export const reportAppHydrated = (initialState = {}) => {
  uninstallWatchdog?.();
  addPageAction("app_hydrated", {
    version: initialState.storeData?.version,
    layout: initialState.content?.layout,
  });
};

export const reportFatalStartupError = (error) => {
  // terminal path: stop the watchdog mislabeling later unrelated errors
  uninstallWatchdog?.();
  noticeError(error, { severity: "fatal", phase: "startup" });
};

// for terminal paths that report through their own channel (e.g. fatal boundary)
export const uninstallHydrationWatchdog = () => {
  uninstallWatchdog?.();
};

export const reportFatalHydrationError = (error) => {
  uninstallWatchdog?.();
  noticeError(error, { severity: "fatal", phase: "hydration" });
};

export const reportRecoverableHydrationError = (error) => {
  noticeError(error, { severity: "warning", phase: "hydration-mismatch" });
};

// Tags uncaught errors between bundle start and hydration commit as fatal
export const installHydrationWatchdog = () => {
  if (typeof window === "undefined" || uninstallWatchdog) return;

  const onUncaughtError = (event) => {
    const error =
      event.error ??
      event.reason ??
      new Error("Uncaught error before hydration completed");
    // one-shot: the page is dead after this, later errors are unrelated noise
    uninstallWatchdog?.();
    noticeError(error, { severity: "fatal", phase: "hydration-uncaught" });
  };

  window.addEventListener("error", onUncaughtError);
  window.addEventListener("unhandledrejection", onUncaughtError);

  uninstallWatchdog = () => {
    window.removeEventListener("error", onUncaughtError);
    window.removeEventListener("unhandledrejection", onUncaughtError);
    uninstallWatchdog = undefined;
  };
};
